import angular from 'angular';
import display from './builder/display.html';
import api from './builder/api.html';

angular.module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/wfHisto/display.html', display);
	$templateCache.put('kform/components/wfHisto/api.html', api);
});
